// These are duplicates of colors imports -
// Not bringing in colors to reduce dependency on theme
// These values are enforced via unit tests
var DN30 = '#1B2638';
var N0 = '#FFFFFF';
var themedBackground = {
  light: N0,
  dark: DN30
};
/**
 * Returns the background color depending on the passed through mode.
 * @param mode
 */

export var getBackground = function getBackground() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  return themedBackground[mode];
};